export default __webpack_public_path__ + "static/media/right-arrow.e1bf0956.svg";